import { createReducer, on } from '@ngrx/store';
import { zefResetState } from '@zerops/zef/core';
import { SettingsBaseState } from './settings-base.model';
import {
  SettingsBaseActionUnion,
  loadSettingsSuccess,
  loadCountryListSuccess,
  loadStackTypeDetailSuccess,
  measureLocationPingsSuccess
} from './settings-base.action';
import { STACK_NAME_TRANSLATIONS_MAP } from './settings-base.constant';

const initialState = new SettingsBaseState();

const actionReducer = createReducer(
  initialState,
  on(
    loadSettingsSuccess,
    (s, { data }): SettingsBaseState => ({
        ...s,
        currencyList: data.currencyList,
        languageList: data.languageList,
        serviceStackList: data.serviceStackList.map((stack) => ({
          ...stack,
          name: STACK_NAME_TRANSLATIONS_MAP[stack.id] ? STACK_NAME_TRANSLATIONS_MAP[stack.id] : stack.name
        })),
        locationList: data.locationList || [],
        objectStorageList: data.objectStorageList || [],
        objectStorageDiskGBytesMax: data.objectStorageDiskGBytesMax ?? null
      })
  ),
  on(
    loadCountryListSuccess,
    (s, { data }): SettingsBaseState => ({
      ...s,
      countryList: data.list
    })
  ),
  on(
    loadStackTypeDetailSuccess,
    (s, { data }): SettingsBaseState => ({
      ...s,
      stackTypeDetailMap: {
        ...s.stackTypeDetailMap,
        [data.id]: {
          ...data,
          name: STACK_NAME_TRANSLATIONS_MAP[data.id] ? STACK_NAME_TRANSLATIONS_MAP[data.id] : data.name
        }
      }
    })
  ),
  on(
    measureLocationPingsSuccess,
    (s, { data }): SettingsBaseState => ({
      ...s,
      locationPingMap: data.locationPingMap,
      fastestLocationId: data.fastestLocationId
    })
  ),
  on(zefResetState, () => initialState)
);

export function settingsBaseReducer(
  state: SettingsBaseState,
  action: SettingsBaseActionUnion
) {
  return actionReducer(state, action);
}
